var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_38",
    "data-name": "Component 4 \\u2013 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.141,
    height: 37.141,
    viewBox: "0 0 37.141 37.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 37.141,
    height: 37.141,
    fill: "#0070ce"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M35.681,11.341a18.626,18.626,0,1,0,1.46,7.229,18.5,18.5,0,0,0-1.46-7.229m-17.473-3.3a2.19,2.19,0,1,1-2.19,2.19,2.19,2.19,0,0,1,2.19-2.19m5.852,18.742s-.554.283-1.028.529-1.072.521-1.734.794a17.86,17.86,0,0,1-1.844.693,5.43,5.43,0,0,1-1.571.292,1.71,1.71,0,0,1-1.312-.523,1.793,1.793,0,0,1-.474-1.263c0-.152.113-1.308.161-1.815s.1-1.091.144-1.716.092-1.28.13-1.919.057-1.191.057-1.642V19.2a8.748,8.748,0,0,0-.083-1.277,2.029,2.029,0,0,0-.231-.746.829.829,0,0,0-.246-.224.673.673,0,0,0-.347-.078.534.534,0,0,0-.207.044c-.532.222-.781.094-.932-.16a.627.627,0,0,1,.154-.848,7.836,7.836,0,0,1,.878-.486l1.39-.695c.548-.274,1.083-.517,1.59-.721a3.6,3.6,0,0,1,1.209-.331.811.811,0,0,1,.747.363,1.157,1.157,0,0,1,.171.613v.116a7.962,7.962,0,0,1-.09.976c-.058.424-.121.946-.187,1.553s-.129,1.319-.187,2.128-.086,1.676-.086,2.608V23.43c0,.4.01.787.028,1.153a2.472,2.472,0,0,0,.173.844,1.134,1.134,0,0,0,.4.5,1.349,1.349,0,0,0,.772.179,3.813,3.813,0,0,0,.659-.067,5.554,5.554,0,0,0,.72-.176c.228-.073.789-.3.82-.32a.642.642,0,0,1,.865.333c.163.425-.209.744-.506.915",
    transform: "translate(0 0.001)",
    fill: "#0070ce"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.77ec8803bd4816353f5e883b719dd4e5.svg";
export { ForwardRef as ReactComponent };